import { Component, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTimepickerModule } from '@angular/material/timepicker';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  providers: [provideNativeDateAdapter()],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatTimepickerModule,
  ],
})
export class InputComponent {
  control = input.required<FormControl<string | number | null>>();
  errorMsg = input<string>('');
  label = input.required<string>();
  placeholder = input<string>('Bitte ausfüllen');
  type = input.required<'text' | 'number' | 'date' | 'time' | 'email' | 'password'>();
}
